<div class="zoom-meeting-dialog">
  <iframe #frame [src]="zoomHostUrl" frameborder="0" (load)="iframeLoaded()" allow="microphone; camera; display-capture" allowfullscreen></iframe>

  @if (collapsed) {
    <div class="zoom-meeting-dialog__overlay">
      <mat-icon class="close-icon" (click)="close()">close</mat-icon>
      <mat-icon class="open-icon" (click)="navigate()">open_in_new</mat-icon>
    </div>
  }
</div>